import { Box } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import React, { memo, MouseEvent } from 'react';
import { ICarrito } from '@/redux/models';
import { Order } from '@/utils/tableUtils';
import { useTablaCarritoV2Props, ViewAs } from '../../logics/useTablaCarritoV2';

// Define the head cells
const headCells: readonly HeadCell[] = [
    {
        id: 'idCarrito', align: 'left',
        disablePadding: false, label: 'ID',
    },
    {
        id: 'nombreCarrito', align: 'left',
        disablePadding: false, label: 'NOMBRE',
    },
    {
        id: 'fechaDeCreacionCarrito', align: 'center',
        disablePadding: false, label: 'FECHA',
    },
    {
        id: 'montoTotal', align: 'left',
        disablePadding: false, label: 'MONTO',
    },
    {
        id: 'usuario', align: 'center',
        disablePadding: false, label: 'USUARIO',
    }
];

interface HeadCellProps {
    headCell: {
        disablePadding: boolean;
        id: keyof ICarrito;
        label: string;
        align: 'left' | 'right' | 'inherit' | 'center' | 'justify' | undefined;
    };
    order: Order;
    orderBy: string;
    createSortHandler: (property: keyof ICarrito) => (event: MouseEvent<unknown>) => void;
}

const HeadCellComponent = memo(({ headCell, order, orderBy, createSortHandler }: HeadCellProps) => (
    <TableCell
        align={headCell.align}
        padding={headCell.disablePadding ? 'none' : 'normal'}
        sortDirection={orderBy === headCell.id ? order : false}
    >
        <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : 'asc'}
            onClick={createSortHandler(headCell.id)}
        >
            {headCell.label}
            {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
            ) : null}
        </TableSortLabel>
    </TableCell>
), (prevProps, nextProps) => {
    return prevProps.order === nextProps.order && prevProps.orderBy === nextProps.orderBy;
});

interface HeadCell {
    disablePadding: boolean;
    id: keyof ICarrito;
    label: string;
    align: 'left' | 'right' | 'inherit' | 'center' | 'justify' | undefined;
}

export function TableCarpetasHead({ order, orderBy, setOrder, setOrderBy, viewAs }: { order: Order, orderBy: string, setOrder: any, setOrderBy: any, viewAs: useTablaCarritoV2Props['viewAs'] }) {

    const createSortHandler =
        (property: keyof ICarrito) => (event: React.MouseEvent<unknown>) => {
            setOrderBy(property);
            setOrder((oldOrder: any) => (orderBy === property && oldOrder === 'desc') ? 'asc' : 'desc');
        };

    return (
        <TableHead>
            <TableRow>
                <TableCell align='center'>
                </TableCell>
                {headCells.map((headCell, index) => {
                
                    if (viewAs === ViewAs.USER && headCell.id === 'usuario') {
                        return null; 
                    }

                    return (
                        <HeadCellComponent
                            key={index}
                            headCell={headCell}
                            order={order}
                            orderBy={orderBy}
                            createSortHandler={createSortHandler}
                        />
                    );
                })}
                <TableCell align='center'>
                    ESTADOS
                </TableCell>
                <TableCell align='center'>
                    ACCIONES
                </TableCell>
            </TableRow>
        </TableHead>
    );
}
